import MileagePageContainer from './MileagePageContainer';

export default MileagePageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/MileagePage/index.js